import { Injectable             } from "@angular/core";
import { TimeTrackerBaseApi     } from '../../providers/generic.service';
import {
    ITimesheetApproval          } from '../../../typings/api';
import { BehaviorSubject        } from "rxjs/BehaviorSubject";
import { ISwipe } from "../../../typings/timetracker/timetracker";

@Injectable()
export class WeekStatusService {

    private userListDailyActivityTotals$: BehaviorSubject<ITimesheetApproval[]> = new BehaviorSubject(null);
    private forgottenSwipes$: BehaviorSubject<ISwipe[]> = new BehaviorSubject(null);

    /**
     * Retrieve the status of the timesheet approval for each (iso) week
     * @param {number} year
     * @param {number} isoWeek
     */
    dispatchUserListDailyActivityTotal( year: number, isoWeek: number ) {
        this.$api.genericGetCall( `/admin/timesheets/approved/${year}/${isoWeek}` )
        .subscribe( ( response ) => { this.userListDailyActivityTotals$.next( response as ITimesheetApproval[] ) } );
    }

    /**
     * Retrieve the status of the timesheet approval for each (iso) week
     * @param {number} year
     * @param {number} isoWeek
     */
    dispatchForgottenSwipeList( year: number, isoWeek: number ) {
      this.$api.genericGetCall( `/admin/swipes/forgotten/${year}/${isoWeek}` )
      .subscribe( ( response ) => {
        console.log( '[FORGOTTEN-SWIPES] response', response)
        this.forgottenSwipes$.next( response as ISwipe[] );
      } );
    }

    /**
     * Select the status of the timesheet approval for each (iso) week
     */
    selectUserListDailyActivityTotals() {
        return this.userListDailyActivityTotals$.asObservable();
    }

    /**
     * Select the list of user that forgot to swipe out
     */
    selectForgottenSwipes() {
      return this.forgottenSwipes$.asObservable();
    }


    constructor( private $api: TimeTrackerBaseApi ) {}
}



// WEBPACK FOOTER //
// ./src/pages/week-status/week-status.service.ts